import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
    min-height: calc(100vh - 56px);
    background-color: #f8fafc;
    padding: 40px 20px;
    display: flex;
    justify-content: center;
`;

const Content = styled.div`
    max-width: 640px;
    width: 100%;
`;

const BackButton = styled.button`
    background: none;
    border: none;
    color: #00205B;
    font-family: 'Roboto', sans-serif;
    font-size: 0.9rem;
    font-weight: 600;
    cursor: pointer;
    padding: 0;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    gap: 6px;

    &:hover {
        text-decoration: underline;
    }
`;

const Title = styled.h1`
    color: #00205B;
    font-size: 2rem;
    font-weight: 700;
    margin: 0 0 8px 0;
`;

const Subtitle = styled.p`
    color: #64748b;
    font-size: 1rem;
    margin: 0 0 32px 0;
`;

const Card = styled.div`
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 24px;
    margin-bottom: 16px;
    display: flex;
    align-items: flex-start;
    gap: 16px;
`;

const IconCircle = styled.div`
    width: 48px;
    height: 48px;
    min-width: 48px;
    border-radius: 50%;
    background: #00205B;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    font-weight: 700;
`;

const CardContent = styled.div`
    flex: 1;
`;

const CardTitle = styled.div`
    font-weight: 700;
    color: #1e293b;
    font-size: 1.1rem;
    margin-bottom: 6px;
`;

const CardDescription = styled.div`
    color: #64748b;
    font-size: 0.9rem;
    line-height: 1.5;
`;

const ComingSoonBadge = styled.span`
    display: inline-block;
    background: #e2e8f0;
    color: #475569;
    font-size: 0.75rem;
    font-weight: 700;
    padding: 3px 10px;
    border-radius: 10px;
    margin-top: 10px;
`;

interface ResourcesProps {
    courseId: string;
    onBack: () => void;
}

const Resources: React.FC<ResourcesProps> = ({ courseId, onBack }) => {
    return (
        <PageContainer>
            <Content>
                <BackButton onClick={onBack}>&larr; Back to {courseId}</BackButton>
                <Title>Resources</Title>
                <Subtitle>{courseId} study resources</Subtitle>

                <Card>
                    <IconCircle>AI</IconCircle>
                    <CardContent>
                        <CardTitle>Interactive Chatbot</CardTitle>
                        <CardDescription>
                            Get step-by-step help on any question. An AI tutor that walks you through
                            the solution, explains concepts, and answers follow-up questions — all
                            tailored to the specific problem you're working on.
                        </CardDescription>
                        <ComingSoonBadge>Coming Soon</ComingSoonBadge>
                    </CardContent>
                </Card>

                <Card>
                    <IconCircle>&#9654;</IconCircle>
                    <CardContent>
                        <CardTitle>Video Solutions</CardTitle>
                        <CardDescription>
                            Watch detailed video walkthroughs for every question. See the full
                            solution process, learn common pitfalls, and build intuition for
                            similar problems on your exams.
                        </CardDescription>
                        <ComingSoonBadge>Coming Soon</ComingSoonBadge>
                    </CardContent>
                </Card>
            </Content>
        </PageContainer>
    );
};

export default Resources;
